<template>
  <div class="card-issue-records">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>门店管理</el-breadcrumb-item>
      <el-breadcrumb-item>发卡记录查询</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片区域 -->
    <el-card class="box-card">
      <!-- 搜索区域 -->
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="店铺">
          <el-select v-model="searchForm.storeId" placeholder="全部店铺" clearable filterable style="width: 180px">
            <el-option
              v-for="store in storeList"
              :key="store.id"
              :label="store.storename"
              :value="store.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发卡来源">
          <el-select v-model="searchForm.quotaSource" placeholder="全部来源" clearable @change="handleQuotaSourceChange" style="width: 130px">
            <el-option label="免费发卡" value="free"></el-option>
            <el-option label="代账发卡" value="agency"></el-option>
          </el-select>
        </el-form-item>
        <!-- 卡片类型：仅在发卡来源选择「免费发卡(free)」时显示 -->
        <el-form-item v-if="searchForm.quotaSource === 'free'" label="卡片类型（免费发卡）">
          <el-select v-model="searchForm.cardType" placeholder="全部类型" clearable style="width: 120px">
            <el-option
              v-for="cardType in cardTypeList"
              :key="cardType.cardType"
              :label="cardType.cardName"
              :value="cardType.cardType"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发卡人">
          <el-input v-model="searchForm.issuerUsername" placeholder="发卡人用户名" clearable style="width: 150px"></el-input>
        </el-form-item>
        <el-form-item label="接收人">
          <el-input v-model="searchForm.receiverUsername" placeholder="接收人用户名" clearable style="width: 150px"></el-input>
        </el-form-item>
        <el-form-item label="发卡时间">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 240px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 记录列表 -->
      <el-table :data="recordList" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="storeName" label="店铺名称" min-width="120"></el-table-column>
        <el-table-column label="卡片信息" min-width="120">
          <template slot-scope="scope">
            <el-tag :type="getCardTypeTag(scope.row.cardType)" size="small">{{ scope.row.cardName }}</el-tag>
            <div style="color: #999; font-size: 12px;">{{ scope.row.cardDays }}天</div>
          </template>
        </el-table-column>
        <el-table-column label="发卡人" min-width="120">
          <template slot-scope="scope">
            <div>{{ scope.row.issuerUsername }}</div>
            <div style="color: #999; font-size: 12px;">{{ scope.row.issuerNickname }}</div>
          </template>
        </el-table-column>
        <el-table-column label="接收人" min-width="140">
          <template slot-scope="scope">
            <div>{{ scope.row.receiverUsername }}</div>
            <div style="color: #999; font-size: 12px;">{{ scope.row.receiverNickname }}</div>
            <div style="color: #999; font-size: 12px;">{{ scope.row.receiverPhone }}</div>
          </template>
        </el-table-column>
        <el-table-column label="有效期" min-width="180">
          <template slot-scope="scope">
            <div>{{ formatDate(scope.row.startTime) }}</div>
            <div>至 {{ formatDate(scope.row.endTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="发卡来源" width="100">
          <template slot-scope="scope">
            <el-tag
              :type="isAgencyRecord(scope.row) ? 'warning' : 'success'"
              size="small"
            >{{ isAgencyRecord(scope.row) ? '代账发卡' : '免费发卡' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="订单号" min-width="160"></el-table-column>
        <el-table-column prop="issueMonth" label="发卡月份" width="100"></el-table-column>
        <el-table-column label="发卡时间" width="160">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.issueTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.remark || '-' }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px; text-align: right;"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CardIssueRecords',
  data() {
    return {
      loading: false,
      recordList: [],
      storeList: [],
      cardTypeList: [],
      searchForm: {
        storeId: null,
        cardType: '',
        quotaSource: '',
        issuerUsername: '',
        receiverUsername: '',
        dateRange: []
      },
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.loadCardTypes()
    this.loadStoreList()
    this.loadRecords()
  },
  methods: {
    // 加载卡片类型列表
    async loadCardTypes() {
      try {
        const res = await axios.get('/cardType/list')
        if (res.data.status === 0) {
          // 转换字段名：下划线转驼峰
          this.cardTypeList = (res.data.data || []).map(item => ({
            id: item.id,
            cardType: item.card_type,
            cardName: item.card_name,
            cardDays: item.card_days,
            sortOrder: item.sort_order,
            isEnabled: item.is_enabled ? 1 : 0
          }))
        }
      } catch (e) {
        console.error('加载卡片类型失败', e)
      }
    },

    async loadStoreList() {
      try {
        const res = await axios.get('/cardIssue/stores')
        if (res.data.status === 0) {
          this.storeList = res.data.data || []
        }
      } catch (e) {
        console.error('加载店铺列表失败', e)
      }
    },

    async loadRecords() {
      this.loading = true
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }

        if (this.searchForm.storeId) {
          params.storeId = this.searchForm.storeId
        }
        if (this.searchForm.cardType) {
          params.cardType = this.searchForm.cardType
        }
        if (this.searchForm.quotaSource) {
          params.quotaSource = this.searchForm.quotaSource
        }
        if (this.searchForm.issuerUsername) {
          params.issuerUsername = this.searchForm.issuerUsername
        }
        if (this.searchForm.receiverUsername) {
          params.receiverUsername = this.searchForm.receiverUsername
        }
        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.startDate = this.searchForm.dateRange[0]
          params.endDate = this.searchForm.dateRange[1]
        }

        const res = await axios.post('/cardIssue/records', params)
        if (res.data.status === 0) {
          this.recordList = res.data.data || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.data.message || '加载失败')
        }
      } catch (e) {
        console.error('加载记录失败', e)
        this.$message.error('加载记录失败')
      } finally {
        this.loading = false
      }
    },

    handleSearch() {
      this.pageNum = 1
      this.loadRecords()
    },

    // 发卡来源切换：仅免费发卡显示卡片类型；切到其它来源时清空卡片类型，避免残留过滤条件
    handleQuotaSourceChange() {
      if (this.searchForm.quotaSource !== 'free') {
        this.searchForm.cardType = ''
      }
    },

    handleReset() {
      this.searchForm = {
        storeId: null,
        cardType: '',
        quotaSource: '',
        issuerUsername: '',
        receiverUsername: '',
        dateRange: []
      }
      this.pageNum = 1
      this.loadRecords()
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.loadRecords()
    },

    handleCurrentChange(val) {
      this.pageNum = val
      this.loadRecords()
    },

    // 代账发卡：quota_source 为 agency（历史数据存在 buy），其余视为免费发卡
    isAgencyRecord(row) {
      const qs = row && row.quotaSource
      return qs === 'agency' || qs === 'buy'
    },

    getCardTypeTag(cardType) {
      const types = {
        'year_card': 'danger',
        'quarter_card': 'warning',
        'month_card': 'success',
        'three_day_card': 'info',
        'day_card': ''
      }
      return types[cardType] || ''
    },

    formatDate(timeStr) {
      if (!timeStr) return ''
      const date = new Date(timeStr)
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    formatTime(timeStr) {
      if (!timeStr) return ''
      const date = new Date(timeStr)
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    }
  }
}
</script>

<style scoped>
.card-issue-records {
  padding: 20px;
}

.box-card {
  margin-top: 20px;
}

.search-form {
  margin-bottom: 20px;
}
</style>
